import {
    Card, CardContent, CardHeader, Grid,
    TextField, Button, Collapse
} from '@mui/material'
import { Alert, Box, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

export default function ProveedorForma() {
    const [proveedor, setProveedor] = useState({
        clave: null,
        rfc: null,
        razonSocial: null,
        //giro: '',
        telefonoContacto: null,
        telefonoOficial: null,
        //representante: '',
        //documentos: new FormData(),
        //rutaIdentificacion: '',
        //rutaCedula: '',
        //rutaEstadoCuenta: ''
        emailRepresentante: null,
        emailComercial: null
    })

    const [loading, setLoading] = useState(false)
    const [editing, setEditing] = useState(false)
    const [open, setOpen] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [severity, setSeverity] = useState('error')
    // const [errorIdentificacion, setErrorIdentificacion] = useState(false)
    // const [helperTextIdentificacion, setHelperTextIdentificacion] = useState('')
    // const [errorCedula, setErrorCedula] = useState(false)
    // const [helperTextCedula, setHelperTextCedula] = useState('')
    // const [errorEstadoCuenta, setErrorEstadoCuenta] = useState(false)
    // const [helperTextEstadoCuenta, setHelperTextEstadoCuenta] = useState('')

    const navigate = useNavigate()

    const params = useParams()

    const handleDocumento = (event, tipo, setHelperText, setError) => {
        proveedor.documentos ? proveedor.documentos.delete(tipo) : proveedor.documentos = new FormData()
        const file = event.target.files[0]
        if (event.target.value) {
            if (event.target.value.endsWith(".PDF") || event.target.value.endsWith(".pdf")) {
                setHelperText('')
                setError(false)
            }
            else {
                setHelperText('Formato de archivo no válido, se requiere PDF')
                setError(true)
                return
            }
            if (file.size > 5242880) {
                setHelperText('El tamaño del archivo debe ser menor a 5MB')
                setError(true)
                return
            }
            else {
                setHelperText('')
                setError(false)
            }
            //console.log(`event.target.value.match(/[A-Za-z0-9_-]/gi) ${event.target.files[0].name.match(/[A-Za-z0-9_-]/gi)} ${event.target.files[0].name.match(/[A-Za-z0-9_-]/gi).length} cadena ${event.target.files[0].name.length}`)
            // Si la longitud coincide significa que sólo se encontraron letras, números y guiones
            if (file.name.match(/[A-Za-z0-9_-]/gi).length === file.name.length - 1) //Se resta uno por el punto de la extensión
            {
                setHelperText('')
                setError(false)
            }
            // Si la longitud no coincide significa que en el match se ignoraron caracteres especiales, resultando una arreglo más corto
            else {
                setHelperText('El nombre del archivo no debe contener caracteres especiales como acentos o espacios en blanco, puede separar palabras con - o _')
                setError(true)
                return
            }
            setHelperText('')
            setError(false)
        }
        console.log(`Files[0] ${file.name}`)
        proveedor.documentos.append(tipo, file)
    }

    const handleCancel = (e) => {
       
        window.location.reload()
        
    }
        
    const handleSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)
        console.log(`proveedor.clave ${proveedor.clave}`)
        console.log(`proveedor.rfc ${proveedor.rfc}`)
        if((!proveedor.clave || proveedor.clave === '') && (!proveedor.rfc || proveedor.rfc === '')){
            setSeverity('error')
            setMensaje('Debe especificar una Clave o RFC')
            setOpen(true)
            setLoading(false)
            return
        }
        setMensaje('')
        setOpen(false)
        if (proveedor.documentos && proveedor.documentos.get('identificacion')) {
            const identificacion = new FormData();
            identificacion.append('documento', proveedor.documentos.get('identificacion'));
            const resUploadIdentificacion = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/uploadDocumentoProveedor`, {
                method: "POST",
                body: identificacion
            })
            const rutaIdentificacion = (await resUploadIdentificacion.json()).ruta
            proveedor.rutaIdentificacion = rutaIdentificacion
        }
        if (proveedor.documentos && proveedor.documentos.get('cedula')) {
            const archivoCedula = new FormData();
            archivoCedula.append('documento', proveedor.documentos.get('cedula'));
            const resUploadCedula = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/uploadDocumentoProveedor`, {
                method: "POST",
                body: archivoCedula
            })
            const rutaCedula = (await resUploadCedula.json()).ruta
            proveedor.rutaCedula = rutaCedula
        }
        if (proveedor.documentos && proveedor.documentos.get('estadoCuenta')) {
            const archivoEstadoCuenta = new FormData();
            archivoEstadoCuenta.append('documento', proveedor.documentos.get('estadoCuenta'));
            const resUploadEstadoCuenta = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/uploadDocumentoProveedor`, {
                method: "POST",
                body: archivoEstadoCuenta
            })
            const rutaEstadoCuenta = (await resUploadEstadoCuenta.json()).ruta
            proveedor.rutaEstadoCuenta = rutaEstadoCuenta
        }

        if (editing) {
            const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/proveedores/${params.id ? params.id : proveedor.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                },
                body: JSON.stringify(proveedor)
            })
            const data = await res.json()
            //colocar un mensaje para orientar al usuario, se está validando desde sequelize
            if(res.status === 200)
                setSeverity('sucess')
            else
                setSeverity('error')
            if (data.message) {
                setOpen(true)
                setMensaje(data.message)
                setLoading(false)
                return
            }
            else {
                setOpen(false)
            }

        }
        else {
            const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/proveedores`, {
                method: "POST",
                body: JSON.stringify(proveedor),
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                },
            })

            const data = await res.json()
            //colocar un mensaje para orientar al usuario, se está validando desde sequelize
            if(res.status === 200)
                setSeverity('success')
            else
                setSeverity('error')
            if (data.message) {
                setOpen(true)
                setMensaje(data.message)
                setLoading(false)
                return
            }
            else {
                setOpen(false)
            }
        }
        setLoading(false)

        navigate('/proveedores')
    }

    const cargarProveedor = async (id) => {
        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/proveedores/byId/${id}`)
        const data = await res.json()
        console.log(`Proveedor leído para editar: ${JSON.stringify(data)}`)
        setProveedor({ ...data })
        setEditing(true) //Estado
    }

    useEffect(() => {
        (async () => {
            if (params.id) {
                await cargarProveedor(params.id)
            }
        })();
    }, [params.id]
    )

    const handleChange = e => {
        setProveedor({ ...proveedor, [e.target.name]: e.target.value })
        //copio todo lo que tenga el proveedor y luego actualizo lo que se está tecleando
    }

    const handleBlurRFC = async (e) => {
        if (editing)
            return
        const rfc = e.target.value
        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/proveedores/rfc/${rfc}`)
        const data = await res.json()
        console.log(`Proveedor leído para editar: ${JSON.stringify(data)}`)
        if (data.rfc) {
            setProveedor({ ...data })
            setEditing(true)
            setSeverity('info')
            setMensaje('Ya existe un proveedor con ese RFC, puede modificarlo')
            setOpen(true)
        }
    }

    const handleBlurClave = async (e) => {
        if (editing)
            return
        const clave = e.target.value
        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/proveedores/clave/${clave}`)
        const data = await res.json()
        console.log(`Proveedor leído para editar: ${JSON.stringify(data)}`)
        if (data.clave) {
            setProveedor({ ...data })
            setEditing(true)
            setSeverity('info')
            setMensaje('Ya existe un proveedor con esa clave, puede modificarlo')
            setOpen(true)
        }
        
    }

    return (
        <Grid container direction='row' justifyContent='center' style={{ marginTop: 50 }}>
            <Grid item xs={12} sm={12}>
                <Card>
                    <CardHeader title={editing ? 'Editar Proveedor' : 'Agregar Nuevo Proveedor'}></CardHeader>
                    <CardContent>
                        <form onSubmit={handleSubmit}>
                            <Grid container direction='row' justifyContent='space-between' spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <TextField sx={{ width: '100%' }} label='Clave' name='clave' onChange={handleChange} onBlur={handleBlurClave} value={proveedor.clave} focused />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField sx={{ width: '100%' }} label='RFC' name='rfc' onChange={handleChange} onBlur={handleBlurRFC} value={proveedor.rfc} focused />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField sx={{ width: '100%' }} label='Razón social' name='razonSocial' multiline onChange={handleChange} value={proveedor.razonSocial} required focused />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField sx={{ width: '100%' }} label='Teléfono de contacto' name='telefonoContacto' multiline onChange={handleChange} value={proveedor.telefonoContacto} focused />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField sx={{ width: '100%' }} label='Teléfono oficial' name='telefonoOficial' onChange={handleChange} value={proveedor.telefonoOficial} focused />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField sx={{ width: '100%' }} label='Email del representante' name='emailRepresentante' multiline onChange={handleChange} value={proveedor.emailRepresentante} focused type='email' />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField sx={{ width: '100%' }} label='Email comercial' name='emailComercial' multiline onChange={handleChange} value={proveedor.emailComercial} focused type='email' />
                                </Grid>
                                
                                <Grid item xs={12} sm={4}>
                                    <Button variant='contained' color='primary' type='submit' style={{ marginTop: 20 }} disabled={loading}>
                                        Guardar
                                    </Button>
                                    <Button variant='contained' color='primary' type='button' style={{ marginTop: 20, marginLeft: 20 }} onClick={handleCancel} disabled={loading}>
                                        Cancelar
                                    </Button>
                                </Grid>
                            </Grid>

                        </form>
                        <Box sx={{ width: '100%' }}>
                            <Collapse in={open}>
                                <Alert severity={severity}
                                    action={
                                        <IconButton
                                            aria-label="close"
                                            color="inherit"
                                            size="small"
                                            onClick={() => {
                                                setOpen(false);
                                            }}
                                        >
                                            <CloseIcon fontSize="inherit" />
                                        </IconButton>
                                    }
                                    style={{ marginTop: 30 }}
                                >
                                    {mensaje}
                                </Alert>
                            </Collapse>
                        </Box>
                    </CardContent>
                </Card>

            </Grid>
        </Grid>
    )
}